import { BasicFrameConfig } from 'InternalLibrary';
import { ContactMail } from '../Contact/ContactMail';
import { ContactPhone } from '../Contact/ContactPhone';
import { memo } from 'react';
import { Spacer, Text } from 'components/atoms';
import classNames from 'classnames';
import Link from 'components/atoms/Link/Link';
import styles from './DesktopFooter.module.scss';

export interface DesktopFooterProps {
  className?: string;
  content: {
    businessHours: string;
    contactEmail: string;
    contactPhone: string;
    termsAndConditionsUrl?: string;
    termsAndConditionsText?: string;
  };
  layout: BasicFrameConfig['footerLayout'];
  showTermsConditions?: boolean;
}

export const DesktopFooter = memo(
  ({
    className,
    content,
    layout,
    showTermsConditions = false,
  }: DesktopFooterProps) => {
    const shouldShowTermsConditions =
      layout === 'default' &&
      showTermsConditions &&
      content.termsAndConditionsUrl &&
      content.termsAndConditionsText;

    return (
      <div
        className={classNames(
          styles.footer,
          layout && styles[`${layout}-layout`],
          className,
        )}
      >
        <div
          className={classNames(
            styles['footer-content'],
            layout && styles[`footer-content-${layout}-layout`],
          )}
        >
          <div>
            <div className={styles['contact-info']}>
              <ContactMail email={content.contactEmail} />
              <Spacer marginRight={'30px'} />
              <ContactPhone phone={content.contactPhone} />
            </div>
            <div className={styles['business-hours']}>
              <Text
                level={3}
                dangerouslySetInnerHTML={{
                  __html: content.businessHours.replace(/\n/g, (match) =>
                    layout === 'centered' ? '<br />' : match,
                  ),
                }}
              />
            </div>
          </div>
          {shouldShowTermsConditions && (
            <div className={styles['terms-conditions-wrapper']}>
              <Link
                className={styles['terms-conditions']}
                href="#"
                onClick={() => {
                  window.open(content.termsAndConditionsUrl);
                }}
              >
                {content.termsAndConditionsText}
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  },
);
